const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const usd0 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

/** Amounts from the API are integer cents — format from there. */
export const fmtCents = (cents: number) => usd.format(cents / 100);
export const fmtCents0 = (cents: number) => usd0.format(cents / 100);
export const fmtNum = (n: number) => n.toLocaleString('en-US');
export const fmtPct = (n: number) => `${n.toFixed(1)}%`;
export const fmtDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

/**
 * Format a date-only value without allowing the browser timezone to move it to
 * the previous/next calendar day. FedEx invoice and SLA dates are normalized by
 * the server before they reach the client.
 */
export const fmtUtcDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });

/** Format an operational instant in the timezone used to evaluate its SLA date. */
export const fmtDateTimeInZone = (iso: string, timeZone: string) => {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
  };
  try {
    return new Date(iso).toLocaleString('en-US', options);
  } catch {
    return new Date(iso).toLocaleString('en-US', { ...options, timeZone: 'UTC' });
  }
};
